import React, { useEffect } from "react";
import { FxLabel } from "./FxLabel";


/**
 * 기본 일자를 가져온다.
 * @param {string} attrDftVal "day,-7" 7일 이전을 의미함.
 * @returns
 */
export function getDefaultDate(attrDftVal) {

  let d = new Date();

  try {
    let ss = attrDftVal.split(",");
    if (ss.length === 2) {
      let dayOfMonth = d.getDate();
      let monthOfYear = d.getMonth()+1;
      let year = d.getFullYear();

      if ("day" === ss[0]) {
        d.setDate(dayOfMonth + Number(ss[1]));
      } else if ("month" === ss[0]) {
        d.setMonth(monthOfYear + Number(ss[1])-1);
      } else if ("year" === ss[0]) {
        d.setFullYear(year + Number(ss[1]));
      }
    }
  } catch (e) {

  }

  return d;
}

/**
 * 숫자로만 구성된 일시를 제공한다.
 * @param {*} value
 * @returns
 */
export function getHstime(value) {
  let ret = "";
  const str = value + "";
  for (const ch of str) {
    if (ch >= "0" && ch <= "9") {
      ret += ch;
    }
  }
  for (let i = ret.length; i < 14; i++) {
    ret += "0";
  }
  return ret;
}

export function getHstimeFromDate(d) {
  // Method	Description
  // getFullYear()	Get year as a four digit number (yyyy)
  // getMonth()	Get month as a number (0-11)
  // getDate()	Get day as a number (1-31)
  // getDay()	Get weekday as a number (0-6)
  // getHours()	Get hour (0-23)
  // getMinutes()	Get minute (0-59)
  // getSeconds()	Get second (0-59)
  // getMilliseconds()	Get millisecond (0-999)
  // getTime()	Get time (milliseconds since January 1, 1970)

  function addZero(i) {
    if (i < 10) { i = "0" + i }
    return i + "";
  }

  let year = d.getFullYear();
  let month = d.getMonth() + 1;
  let day = d.getDate();
  let hh = d.getHours();
  let mi = d.getMinutes();
  let ss = d.getSeconds();

  return year + addZero(month) + addZero(day) + addZero(hh) + addZero(mi) + addZero(ss);
}


export function getDate(value) {
  let ret = "";
  const str = value + "";
  for (const ch of str) {
    if (ch >= "0" && ch <= "9") {
      ret += ch;
    }
  }
  return ret.length >= 8 ? ret.substring(0, 8) : ret;
}


function render(value, opt) {
  const s = getDate(value);
  try {
    return opt === 'month'? s.slice(0, 4) + "-" + s.slice(4, 6) : s.slice(0, 4) + "-" + s.slice(4, 6) + "-" + s.slice(6, 8);
  } catch (e) {
    return value;
  }
}

function isEmpty(s) {
  return s === undefined || s === null || s.length === 0;
}


export const FxDate = (props) => {
  const { attr, onChangeValue, fxInObj, inputType } = props;
  const disabled = attr.readOnlyYn === "Y";
  const sx = { width: "160px" };

  let defaultValue = fxInObj[attr.attrName];
  if (isEmpty(defaultValue)) defaultValue = getHstimeFromDate(getDefaultDate(attr.attrDftVal));

  const onChange = (event) => {
    const vals = event.target.value.split("");
    setInputData(event.target.id, vals);
  };

  function setInputData(id, value) {
    console.log("*** FxDateTime ***", value);
    onChangeValue(id, getDate(value));
  }

  useEffect(() => {
    //로딩되면 입력객체에 값을 설정한다.
    setInputData(attr.attrName, defaultValue);
  }, [attr]);

  return (
    <>
      <FxLabel attr={attr} inputType={inputType} />
      <input
        className="FxDate"
        type="date"
        id={attr.attrName}
        style={sx}
        defaultValue={render(defaultValue)}
        disabled={disabled}
        onChange={onChange}
        onClick={onChange}
      />
    </>
  );
};

// ATTR_TYPE_CD 를 dateMonth로 작성시
export const FxDateMonth = (props) => {
  const { attr, onChangeValue, fxInObj, inputType } = props;
  const disabled = attr.readOnlyYn === "Y";
  const sx = { width: "160px" };

  let defaultValue = fxInObj[attr.attrName];
  if (isEmpty(defaultValue)) defaultValue = getHstimeFromDate(getDefaultDate(attr.attrDftVal));

  const onChange = (event) => {
    const vals = event.target.value.split("");
    setInputData(event.target.id, vals);
  };

  function setInputData(id, value) {
    console.log("*** FxDateTime ***", value);
    onChangeValue(id, getDate(value));
  }

  useEffect(() => {
    //로딩되면 입력객체에 값을 설정한다.
    setInputData(attr.attrName, defaultValue);
  }, [attr]);

  return (
    <>
      <FxLabel attr={attr} inputType={inputType} />
      <input
        className="FxDate"
        type="month"
        id={attr.attrName}
        style={sx}
        defaultValue={render(defaultValue, 'month')}
        disabled={disabled}
        onChange={onChange}
        onClick={onChange}
      />
    </>
  );
};


export const FxDate2 = (props) => {
  const { attrClass, para } = props;
  const sx = attrClass.getStyle();
  let defaultValue = props.defaultValue;
  if (isEmpty(defaultValue)) defaultValue = getHstimeFromDate(getDefaultDate(attrClass.getAttr().attrDftVal));

  sx.minWidth = "250px";
  sx.width = sx.minWidth;

  console.log("*** FxDate ***   defaultValue", defaultValue);
  console.log("*** FxDate ***   defaultValue", render(defaultValue));


  const onChange = (event) => {
    const vals = event.target.value.split("");
    setInputData(event.target.id, vals);
  };

  function setInputData(id, value) {
    if (para.onChange) para.onChange(id, getDate(value));
  }

  useEffect(() => {
    //로딩되면 입력객체에 값을 설정한다.
    setInputData(attrClass.getId(), defaultValue);
  }, [attrClass]);

  return (
    <>
      <input
        className="FxDate"
        type="date"
        id={attrClass.getId()}
        style={sx}
        defaultValue={render(defaultValue)}
        disabled={attrClass.isDisable()}
        onChange={onChange}
        onClick={onChange}
      />
    </>
  );
};


export const FxEmptyDate = (props) => {
  const { attrClass, para } = props;
  const sx = attrClass.getStyle();

  sx.minWidth = "250px";
  sx.width = sx.minWidth;

  const onChange = (event) => {
    const vals = event.target.value.split("");
    setInputData(event.target.id, vals);
  };

  function setInputData(id, value) {
    if (para.onChange) para.onChange(id, getDate(value));
  }

  useEffect(() => {
    //로딩되면 입력객체에 값을 설정한다.
    setInputData(attrClass.getId());
  }, [attrClass]);

  return (
    <>
      <input
        className="FxDate"
        type="date"
        id={attrClass.getId()}
        style={sx}
        disabled={attrClass.isDisable()}
        onChange={onChange}
        onClick={onChange}
      />
    </>
  );
};
